import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import GroupPage from "./pages/GroupPage";
import ChurchesPage from "./pages/ChurchesPage";
import ChurchDetailPage from "./pages/ChurchDetailPage";
import AdminPage from "./pages/AdminPage";
import InviteSignupPage from "./pages/InviteSignupPage";
import DonatePage from "./pages/DonatePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import { I18nProvider } from "./i18n/useTranslation";

// Auth is sent via Bearer token in Authorization header (read from sessionStorage).
// withCredentials is intentionally NOT enabled so CORS can use "*" across preview/prod domains.
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("auth_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401/403, clear session and redirect to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      const isAuthRoute = error.config?.url?.includes("/auth/");
      if (!isAuthRoute) {
        sessionStorage.removeItem("auth_token");
        localStorage.removeItem("user");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/groups/:groupId" element={<GroupPage />} />
        <Route path="/churches" element={<ChurchesPage />} />
        <Route path="/churches/:churchId" element={<ChurchDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/invite" element={<InviteSignupPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
      </Routes>
    </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
